import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useRef } from 'react';
import { propFunc, propBool, propOneOf, } from '../../../../../helpers/custom-prop-types';
import Tooltip from '../../../../Ui/Tooltip/Tooltip';
import ProfessionalUnitCompanySubscribeDeliveryList from '../../Parts/ProfessionalUnitCompanySubscribeDeliveryList';
import ProfessionalUnitCompanyContactSubscribe from './ProfessionalUnitCompanyContactSubscribe';
const ProfessionalUnitCompanyContactButton = (props) => {
    const { checked, onChange: rawOnChange, showAlertModal, showSubscribeModal, userMode, } = props;
    const tooltipRef = useRef();
    const popperOptions = useMemo(() => ({
        modifiers: [
            {
                enabled: true,
                fn(data) {
                    data.instance.popper.classList.add('professional_unit_subscribe_tooltip');
                    return data;
                },
                name: 'addClassName',
            },
        ],
    }), []);
    const onChange = useCallback((value) => {
        if (tooltipRef.current && !value && userMode === 'view') {
            const element = document.querySelector('.professional_unit_subscribe_tooltip');
            if (element) {
                const { display } = window.getComputedStyle(element);
                // メディアクエリで設定したスタイルの有無で挙動を変える
                if (display === 'none') {
                    showSubscribeModal();
                    return;
                }
            }
        }
        rawOnChange(value);
    }, [rawOnChange, tooltipRef, showSubscribeModal, userMode]);
    return (_jsx(Tooltip, Object.assign({ disabled: checked, distance: -10, html: _jsx(ProfessionalUnitCompanySubscribeDeliveryList, { className: 'is-tooltip', description: _jsx("div", Object.assign({ className: 'delivery_tooltip_title' }, { children: "\u4E0B\u8A18\u306E\u6700\u65B0\u60C5\u5831\u3092\u30E1\u30FC\u30EB\u3067\u304A\u77E5\u3089\u305B" })) }), popperOptions: popperOptions, position: 'left', theme: 'light', tooltipRef: tooltipRef, trigger: 'mouseenter' }, { children: _jsx(ProfessionalUnitCompanyContactSubscribe, { checked: checked, onChange: onChange, showAlertModal: showAlertModal, userMode: userMode }) })));
};
ProfessionalUnitCompanyContactButton.propTypes = {
    checked: propBool().isRequired,
    onChange: propFunc().isRequired,
    showAlertModal: propFunc().isRequired,
    showSubscribeModal: propFunc().isRequired,
    userMode: propOneOf(['view', 'guest', 'other', 'pre']).isRequired,
};
export default ProfessionalUnitCompanyContactButton;
